<template>
<div class="chapter">
<div class="inner_page">
<h1 class="western2" id="calibre_pb_6"><a id="CRIMSON_SKIES"></a> <span class="c5">CRIMSON SKIES</span></h1>
<p class="western1"> <br class="calibre2"/></p>
<p class="western1"> <br class="calibre2"/></p>
<p class="western1">The nation was brought to its knees in early
November with the devastating earthquake that ripped the country
apart at the New Madrid fault line. Thousands of lives were lost
and the actual count would never truly be known. When the shipping
lines were completely cut off from west to east, everyone felt the
impact, especially small towns like Moose Creek. The final blow
came when the power was cut in the middle of winter. Allexa Smeth
was activated in her once quiet role of township emergency manager.
Nothing would ever be the same for her again.</p>
<p class="western1">Spring brought relief from many problems that
plagued Moose Creek during that long and cold winter; gardens were
planted; children went back to school; life resumed. But Mother
Nature wasn’t done.</p>
<p class="western1">The New Madrid earthquake was devastating,
but the quake that woke up the seething caldera beneath Yellowstone
National Park was massive, and the results were nothing short of
catastrophic. The ash clouds that drifted across the country killed
hundreds of thousands of humans and animals alike, in a matter of a
week.</p>
<p class="western1">Allexa’s heart ached when John left again and
he knew that would happen. He also knew that Dr. Mark Robbins was
secretly in love with Allexa, and asked him to stay with her during
the dark time ahead.</p>
<p class="western1">Allexa Smeth was once again struggling to
save what was left of her family and her town.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tmp_648f5cba11b35594391da1bef1608eec_YkgYR9.ch.fixed.fc.tidied.stylehacked.xfixed_split_007.vue?ba4cf5a4